module.exports = __webpack_public_path__ + "img/speaker_10.c6c5291b.jpg";